import * as preload from 'dompack/extra/preload';
module.exports = { promiseImage: preload.promiseImage
                 , promiseScript: preload.promiseScript
                 };



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/system/nodejs/compat/preload.es